import * as React from 'react';
import {TimePicker} from 'antd';
import BaseFormItem, {BaseFormItemProps} from './BaseFormItem';
import * as moment from 'moment';
import {MOMENT_TIME_FORMAT} from "../../utils/date-utils";


interface TimePickerFormItemProps extends BaseFormItemProps {
    onChange?: (date: moment.Moment, dateString: string) => void;
    minTime?: moment.Moment;
    maxTime?: moment.Moment;
    minuteStep?: number;
}

class TimePickerFormItem extends React.Component<TimePickerFormItemProps, {}> {

    public render(): React.ReactNode {
        const {disabled, onChange, minuteStep} = this.props;
        return (
            <BaseFormItem
                {...this.props}
                input={
                    <TimePicker
                        className="mild-disabled"
                        disabled={disabled}
                        minuteStep={minuteStep}
                        allowClear={false}
                        format={MOMENT_TIME_FORMAT}
                        disabledHours={this.collectDisabledHours}
                        disabledMinutes={this.collectDisabledMinutes}
                        onChange={onChange}
                    />}
            />
        );
    }

    private collectDisabledHours = (): number[] => {
        const disabledHours: number[] = [];
        const min = this.props.minTime?.hour();
        const max = this.props.maxTime?.hour();

        for (let i = 0; i <= 23; i++) {
            if (min && i < min) {
                disabledHours.push(i);
            }
            if (max && i > max) {
                disabledHours.push(i);
            }
        }
        return disabledHours;
    }

    private collectDisabledMinutes = (hour: number): number[] => {
        const {minTime, maxTime} = this.props;
        const disabledMinutes: number[] = [];
        const min = minTime;
        const max = maxTime;

        for (let i = 0; i <= 59; i++) {
            if (min && hour === min.hour() && i < min.minute()) {
                disabledMinutes.push(i);
            }
            if (max && hour === max.hour() && i > max.minute()) {
                disabledMinutes.push(i);
            }
        }
        return disabledMinutes;
    }
}

export default TimePickerFormItem;


// WEBPACK FOOTER //
// ./src/common/form-items/TimePickerFormItem.tsx